import { ShareSheetItem } from '../../ShareSheetItem/ShareSheetItem'
import CloudDownload from 'almanac-ui/icons/16/CloudDownload'
import { useModals } from 'almanac-ui/Modal'
import { useShareSheetContext } from '../../ShareSheetV2'
import { ExportToFile } from 'components/ExportModal/ExportToFile'
import { noop } from 'lodash'
import { DesignDownloadModal } from 'components/DesignDownloadModal/DesignDownloadModal'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignDownloadDrawer } from 'components/DesignDownloadModal/DesignDownloadDrawer'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  halfWidth?: boolean
  fullWidth?: boolean
}

const DownloadDocument = observer((props: Props) => {
  const { openModal, closeModal } = useModals()
  const { asset } = useShareSheetContext()
  const { drawersStore } = useRootStore()

  const currentWorkspaceId = useCurrentWorkspaceId()

  return (
    <ShareSheetItem
      {...props}
      icon={<CloudDownload size={24} />}
      title="Download"
      description="HTML, PDF, Markdown"
      onClick={() => {
        asset &&
          openModal(ExportToFile, {
            article: { ...asset, company_id: currentWorkspaceId, channel: asset.channel as ChannelType },
            onSuccess: noop,
            onCancel: closeModal,
            backButtonLocation: 'header',
          })
        drawersStore.closeDrawer()
      }}
    />
  )
})

const DownloadDesign = observer((props: Props) => {
  const { openModal } = useModals()
  const { drawersStore } = useRootStore()
  const { isMobile } = useResponsiveDesign()

  const fileId = useShareSheetContext().file.id

  return (
    <ShareSheetItem
      {...props}
      icon={<CloudDownload size={24} />}
      title="Download"
      description="Image, Video"
      onClick={() => {
        if (isMobile) {
          drawersStore.openDrawer(DesignDownloadDrawer, { fileId })

          return
        }

        openModal(DesignDownloadModal, {
          fileId: fileId,
          showBackButton: true,
        })
      }}
    />
  )
})

export const DownloadItem = (props: Props) => {
  const { file } = useShareSheetContext()

  if (!file) return null

  if (file.type === 'article') {
    return <DownloadDocument {...props} />
  }

  if (file.type === 'design') {
    return <DownloadDesign {...props} />
  }

  return null
}
